import {
    UPDATE_TXN_TOTAL,
    UPDATE_STORE_ID_CHECKOUT,
    UPDATE_API_TOKEN_CHECKOUT,
    UPDATE_CHECKOUT_ID_CHECKOUT,
    RESET_CONFIGURATION_CHECKOUT,
    SELECT_STEP_CHECKOUT,
    SELECT_RESPONSE_CHECKOUT,
    CHECKOUT_PRELOAD_REQUEST_SENT,
    CHECKOUT_PRELOAD_REQUEST_SUCCESS,
    CHECKOUT_PRELOAD_REQUEST_FAIL,
    SELECT_LEFT_SAMPLE_SHOW,
    SELECT_RIGHT_SAMPLE_SHOW,
    TOGGLE_STEPS_LIST_CHECKOUT,
    TOGGLE_RESPONSE_LIST_CHECKOUT,
    SELECT_IF_DISPLAY_IFRAME,
    CHECKOUT_RECEIPT_SENT, 
    CHECKOUT_RECEIPT_SUCCESS,
    CHECKOUT_RECEIPT_FAIL,
    UPDATE_TICKET_CHECKOUT,
    SELECT_NOT_DISPLAY_IFRAME,
    SET_TERMINATE_CHECKOUT,
    SET_NOT_TERMINATE_CHECKOUT,
    SET_DISPLAY_CHECKOUT,
    SET_NOT_DISPLAY_CHECKOUT,
    UPDATE_CALLBACK_CONSOLE,
    SET_SHOW_CALLBACK_CONSOLE,
    SET_NOT_SHOW_CALLBACK_CONSOLE,
    SET_PRELOAD_REQEUST_MESSAGE,
    UPDATDE_FIRST_FIELD,
    UPDATDE_SECOND_FIELD,
    UPDATDE_THIRD_FIELD,
    SELECT_MODE_CHECKOUT,
    OPEN_ALL_TABLES,
    _MCO
} from "./types"

// var requestCode = '{"store_id":"#STOREID#","api_token":"#APITOKEN#","checkout_id":"#CHECKOUTID#","ticket":"#TICKET#","environment":"qa","action":"receipt"}';


export const openAllTables = (ifOpen) => dispatch => {
    dispatch({feature: _MCO, type:OPEN_ALL_TABLES,payload:ifOpen})
}

export const selectMode = (mode) => dispatch => {
    dispatch({feature: _MCO, type:SELECT_MODE_CHECKOUT, payload:mode})
}

export const setFirstField = (updateFirst) => dispatch => {
    dispatch({feature: _MCO, type: UPDATDE_FIRST_FIELD , payload:updateFirst});
}

export const setSecondField = (updateSecond) => dispatch => {
    dispatch({ feature: _MCO, type: UPDATDE_SECOND_FIELD , payload:updateSecond});
}

export const setThirdField = (updateThird) => dispatch => {
    dispatch({ feature: _MCO, type: UPDATDE_THIRD_FIELD , payload:updateThird});
}


export const setPreloadRequestMessage = (updateMessage) => dispatch => {
    dispatch({ feature: _MCO, type: SET_PRELOAD_REQEUST_MESSAGE , payload:updateMessage});
}


export const setShowCalllback = () => dispatch => {
    dispatch({ feature: _MCO, type: SET_SHOW_CALLBACK_CONSOLE});
}
export const setNotShowCalllback = () => dispatch => {
    dispatch({ feature: _MCO, type: SET_NOT_SHOW_CALLBACK_CONSOLE});
}

export const updateCallbackConsole = (updateMessage) => dispatch => {
    dispatch({ feature: _MCO, type: UPDATE_CALLBACK_CONSOLE , payload:updateMessage});
}



export const setTerminateCheckout= () => dispatch => {
    dispatch({ feature: _MCO, type: SET_TERMINATE_CHECKOUT });
}

export const setNotTerminateCheckout= () => dispatch => {
    dispatch({ feature: _MCO, type: SET_NOT_TERMINATE_CHECKOUT });
}

export const setDisplayCheckout= () => dispatch => {
    dispatch({ feature: _MCO, type: SET_DISPLAY_CHECKOUT });
}

export const setNotDisplayCheckout= () => dispatch => {
    dispatch({ feature: _MCO, type: SET_NOT_DISPLAY_CHECKOUT });
}





export const makeReceiptRequest = ({ storeId, apiToken, checkoutId,ticket }) => async dispatch => {
    dispatch({feature: _MCO, type:SELECT_NOT_DISPLAY_IFRAME});
    dispatch({ feature: _MCO, type: CHECKOUT_RECEIPT_SENT });
    try {
        let response = await fetch('https://gatewayt.moneris.com/chktv2/request/request.php', {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            //mode: 'no-cors',
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                checkout_id: checkoutId,
                ticket: ticket,
                environment: "qa",
                action: "receipt"
            }),
        })
        let responseJson = await response.json();
        dispatch({ feature: _MCO, type: CHECKOUT_RECEIPT_SUCCESS, payload: responseJson });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCO, type: CHECKOUT_RECEIPT_FAIL, payload: 'Error, please try again.' });
    }
}


export const updateTicket = (ticketNumber) => dispatch => {
    dispatch({ feature: _MCO, type: UPDATE_TICKET_CHECKOUT, payload: ticketNumber });
}


export const toggleDisplayIframe = () => dispatch => {
    dispatch({ feature: _MCO, type: SELECT_IF_DISPLAY_IFRAME });
}

export const setNotDisplayIframe = () => dispatch => {
    dispatch({ feature: _MCO, type: SELECT_NOT_DISPLAY_IFRAME });
}





export const toggleRightSampleShow = () => dispatch => {
    dispatch({ feature: _MCO, type: SELECT_RIGHT_SAMPLE_SHOW });
}

export const toggleLeftSampleShow = () => dispatch => {
    dispatch({ feature: _MCO, type: SELECT_LEFT_SAMPLE_SHOW });
}


export const updateStoreId = (storeID) => dispatch => {
    dispatch({ feature: _MCO, type: UPDATE_STORE_ID_CHECKOUT, payload: storeID });
}

export const updateApiToken = (ApiToken) => dispatch => {
    dispatch({ feature: _MCO, type: UPDATE_API_TOKEN_CHECKOUT, payload: ApiToken })
}

export const updateCheckoutId = (CheckOutId) => dispatch => {
    dispatch({ feature: _MCO, type: UPDATE_CHECKOUT_ID_CHECKOUT, payload: CheckOutId })
}

export const updateTxnTotal = (TxnTotal) => dispatch => {
    dispatch({ feature: _MCO, type: UPDATE_TXN_TOTAL, payload: TxnTotal })
}

export const resetConfiguration = () => dispatch => {
    dispatch({ feature: _MCO, type: RESET_CONFIGURATION_CHECKOUT });
}

export const selectStep = (stepId) => dispatch => {
    dispatch({ feature: _MCO, type: SELECT_STEP_CHECKOUT, payload: stepId });
    switch (stepId) {
        case 1:
            dispatch({feature: _MCO, type:SELECT_NOT_DISPLAY_IFRAME});
            dispatch({ feature: _MCO, type: SELECT_RESPONSE_CHECKOUT, payload: 1 });
            break;
        default:
            break;
    }
}


export const selectResponse = (responseId) => dispatch => {
    dispatch({ feature: _MCO, type: SELECT_RESPONSE_CHECKOUT, payload: responseId });
}

export const toggleStepsList = () => dispatch => {
    dispatch({ feature: _MCO, type: TOGGLE_STEPS_LIST_CHECKOUT });
}

export const toggleResponseList = () => dispatch => {
    dispatch({ feature: _MCO, type: TOGGLE_RESPONSE_LIST_CHECKOUT });
}




export const makePreloadRequest = (preloadMessage, storeId, apiToken, checkoutId, txnTotal) => async dispatch => {
    dispatch({ feature: _MCO, type:SELECT_NOT_DISPLAY_IFRAME});
    dispatch({ feature: _MCO, type: CHECKOUT_PRELOAD_REQUEST_SENT });
    try {
        let response = await fetch('https://gatewayt.moneris.com/chktv2/request/request.php', {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                checkout_id: checkoutId,
                txn_total: txnTotal,
                environment: "qa",
                action: "preload"
            })
        })
        let responseJson = await response.json();
        dispatch({ feature: _MCO, type: CHECKOUT_PRELOAD_REQUEST_SUCCESS, payload: responseJson });
        dispatch({ feature: _MCO, type: UPDATE_TICKET_CHECKOUT, payload: responseJson.response.ticket});
    } catch (error) {
        console.log("////" + error);
        dispatch({ feature: _MCO, type: CHECKOUT_PRELOAD_REQUEST_FAIL, payload: 'Error, please try again.' });
    }
}


